import { Payment_Data } from "./basket";
import { ApiResult } from "./PromiseResult";
import { InvoicePrint } from "./transactions";
import { TabView_Data } from "./util.models";

export class PackageModel {
    id: string = '';
    package_name: string = '';
    expiry: string = '';
    color_code: string = '';
    image_mobile: string = '';
    image_web: string = '';
    price_image: string = '';
    description: string[] = [];
    amount: string = ''; // $1
    renderedAmount = '';
    package_consultation_count: ConsultationCountModel[] = [];
}


export class PackageStatusModel {
    package_type: {
        package_name: string;
        vendor_guid: string;
    };
    package_record_number: string = '';
    nickname: string = '';
    final_name: string = '';
    expiry_date: string = '';
    expires_at: Date;
    user_package_count: ConsultationStatusModel[] = [];
    id: string;
    has_extended: boolean;
}

export class ConsultationCountModel {
    consultation_type: {
        id: number;
        consultation_name: string;
    };
    max_limit: number = 0;
}

export class ConsultationStatusModel extends ConsultationCountModel {
    current_count: number = 0;
    consultation_type_id: number = null;
    specialty_id: number = null;
    d_specialty_type: {
        id: number;
        specialty_name: string;
    }
    priority_type_id: number = null;
}

export class PackageFormBody {
    package_id: string = null;
    nickname: string = "";
    purchase_package: boolean = false;
}

export class PackagesData {
    selected_packages: PackageFormBody = new PackageFormBody();
    selected_package_travelling: PackageFormBody = new PackageFormBody();
    tabview_Data: TabView_Data = new TabView_Data(0, 1);
    packages: PackageModel[] = [];
    packages_india: PackageModel[] = [];
    packages_usa_india: PackageModel[] = [];
    package_status: PackageStatusModel[] = [];
    paymentData: Payment_Data = new Payment_Data();
    packages_list_api_result: ApiResult = new ApiResult(false);
    packages_submit_api_result: ApiResult = new ApiResult(false);
    packages_extend_api_result: ApiResult = new ApiResult(false);
    print_data: InvoicePrint = new InvoicePrint();
    country: string = '';
    constructor(min_tab: number, max_tab: number) {
        this.tabview_Data = new TabView_Data(min_tab, max_tab);
    }
}
